import { allAbsorptionsData } from "src/config/absorptionsData";

export default function getAbsorptionData(absorption: string | null) {
  const absorptionData = allAbsorptionsData.find(
    (data: any) => data.level === absorption
  );

  if (absorptionData) {
    return absorptionData;
  } else {
    return null;
  }
}
